export default {
    area: 'Area',
    name: 'Name',
    first_name: 'First name',
    last_name: 'Last name',
    english_name: 'English name',
    local_name: 'Local name',
    email: 'Email',
    phone: 'Phone number',
    key: 'Key',
    prefix: 'Prefix',
    information: 'Information',
    description: 'Description',
    description_en: 'ENG description',
    description_da: 'DA description',
    role_description_en: 'En role description',
    role_description_da: 'DA role description',
    file: 'File',
    category: 'Category',
    file_en: 'ENG file',
    file_da: 'DA file',
    image: 'Image',
    title: 'Title',
    title_en: 'ENG title',
    title_da: 'DA title',
    project: 'Project',
    projects: 'Projects',
    project_name: 'Project name',
    project_owner: 'Project owner',
    project_description: 'Project description',
    company_name: 'Company name',
    address: 'Address',
    street: 'Street',
    city: 'City',
    zipcode: 'Zip code',
    floor: 'Floor',
    door: 'Door',
    country: 'Country',
    privacy_url: 'Privacy URL',
    website_url: 'Website URL',
    vat_number: 'VAT number',
    app_store_url: 'App store URL',
    google_play_url: 'Google play URL',
    rooms_count: 'Rooms count',
    title_number: 'Title number',
    variant_type: 'Variant type',
    unit_group: 'Unit group',
    type: 'Type',
    communication_channel: 'Communication channel',
    event_start_time: 'Event start time',
    event_end_time: 'Event end time',
    contract_date: 'Contract date',
    role: 'Role',
    ticket_title: 'Ticket title',
    ticket_message: 'Ticket message',
    ticket_project: 'Ticket project',
    ticket_property: 'Ticket property',
    ticket_reporter: 'Ticket reporter',
    ticket_type: 'Ticket type',
    ticket_category: 'Ticket category',
    ticket_assignee: 'Ticket assignee',
    ticket_priority: 'Ticket priority',
    ticket_status: 'Ticket status',
    role_assignee: 'Role assignee',
    price: 'Price',
    min_bookable_blocks: 'Min bookable blocks',
    max_bookable_blocks: 'Max bookable blocks',
    max_bookings_per_block: 'Max bookings per block',
    price_per_block: 'Price per block',
    move_in_date: 'Move-in date',
    internal: 'Internal',
    rent: 'Rent',
    deposit: 'Deposit',
    water: 'Water',
    heating: 'Heating',
    power: 'Power',
    internet: 'Internet',
    prepaid_rent: 'Prepaid rent',
    total_paid: 'Total paid',
    future_rent: 'Future rent',
    private: 'Private',
    old_password: 'Old password',
    new_password: 'New password',
    password_confirm: 'Confirm password',
    gender: 'Gender',
    age: 'Age',
    birthday: 'Birthday',
    cpr: 'CPR number',
    number: 'Number',
    interested_from: 'Interested from',
    corporation: 'Corporation',
    external_id: 'External id',
    motivation: 'Motivation',
    about_me: 'About me',
    unit_type: 'Unit type',
    rooms: 'Rooms',
};
